module.exports = __webpack_public_path__ + "img/dyson.084a8666.png";